import { PureComponent, useEffect, useState, useCallback } from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import { Icon, BrandLogo } from '@vzmi/shp_shared_compo'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import { APP_TITLE } from '../../constants/general'
import styles from './Header.css'

if (typeof window !== 'undefined') {
  require('@vzmi/shp_shared_compo/modern-web/webcomponents/ScmHeader/index.js')
}

export const FunctionIcon = (props) => {
  return (
    <Icon
      {...props}
      size={props.size || 30}
      style={{ verticalAlign: '-5px' }}
      color='#2b1f9e'
    />
  )
}

export class SimpleHeader extends PureComponent {
  render () {
    const { className } = this.props
    const classes = classNames(styles.pageHeader, { [className]: !!className })
    return (
      <header
        data-role='header'
        className={classes}
      >
        <div className={`navbar ${styles.navbar}`}>
          <nav className={`navbar-color ${styles.navbarColor}`}>
            <div className={`navbar-wrapper ${styles.navbarWrapper}`}>
              <div className={styles.logoWrapper}>
                <a
                  data-role='logo-link'
                  className={styles.logo}
                  href='/'
                >
                  <BrandLogo title={APP_TITLE} />
                </a>
              </div>
            </div>
          </nav>
        </div>
      </header>
    )
  }
}

const defaultNotificationsData = _.times(5).map(() => ({}))
const useNotificationsData = (props) => {
  const { actions = {}, user } = props
  const isPM = _.get(user, 'identity.isPM', false)
  const [notifications, setNotifications] = useState(defaultNotificationsData)

  const initNotificationsData = useCallback(async () => {
    const [error, data] = await safeAwait(
      actions.fetchNotifications({ Page: 1, PageSize: 5 })
    )
    if (error) {
      console.error(error)
      setNotifications([])
      return
    }

    const notificationsData = _.get(data, 'payload.Data')
    setNotifications(notificationsData || [])
  }, [actions])

  useEffect(() => {
    if (isPM) {
      return
    }

    initNotificationsData()
  }, [initNotificationsData, isPM])

  return { data: notifications }
}

const Header = (props) => {
  const { page = {}, className, isHideNavigation = false } = props
  const user = _.get(page, 'user', {})
  const env = _.get(page, 'env', '')
  const isPM = _.get(user, 'identity.isPM', false)
  const { data: notifications } = useNotificationsData(props)
  const classes = classNames(styles.pageHeader, { [className]: !!className })
  const privilegedPages = isPM ? [] : _.get(page, 'privilegedPages', [])
  return (
    <header
      data-role='header'
      className={classes}
    >
      <div className='scm-root'>
        <div
          className='scm-header-area'
          data-is-pm={isPM}
          data-is-hide-navigation={isHideNavigation}
        >
          <scm-header
            user={JSON.stringify(user)}
            privileged-pages={JSON.stringify(privilegedPages)}
            notifications={JSON.stringify(notifications)}
            env={env}
            is-hide-navigation={isHideNavigation}
            is-enable-sso-dot-done
          />
        </div>
      </div>
    </header>
  )
}

export default Header
